'use client';

import { LinkStyled } from '@components/common';
import { VideoCameraIcon } from '@heroicons/react/20/solid';
import { Trans, useTranslation } from 'next-i18next';

/**
 * @description Banner to prompt the user to start an AI interview.
 */
export const StartAiInterviewProfileBanner = () => {
  const { t } = useTranslation();

  return (
    <div className="rounded-lg border-4 border-secondary/15 shadow-banner">
      <div className="flex size-full flex-col items-center justify-between gap-4 rounded border border-dashed border-secondary bg-gradient-to-b from-surface to-surface-50 p-6 sm:flex-row sm:gap-10">
        <div className="text-ink">
          <h2 className="flex items-center gap-2 font-bold">
            {t('ai.interview.banner.title')}
          </h2>
          <p>
            <Trans
              i18nKey="ai.interview.banner.description"
              components={{
                strong: <strong />,
              }}
            />
          </p>
        </div>
        <LinkStyled
          color="secondary"
          styling="solid"
          rounding="full"
          href="/ai-interview?autostart=1"
          className="flex shrink-0 gap-2.5 !font-bold"
        >
          <VideoCameraIcon className="size-5" />
          {t('ai.interview.banner.cta')}
        </LinkStyled>
      </div>
    </div>
  );
};
